const BASE = process.env.REACT_APP_API_URL || '/api';

function token() {
  return localStorage.getItem('calliope_token');
}

async function req(method, path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token() ? { Authorization: `Bearer ${token()}` } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || 'Request failed');
  return data;
}

export const api = {
  signup: (email, password, name) => req('POST', '/auth/signup', { email, password, name }),
  login:  (email, password)       => req('POST', '/auth/login',  { email, password }),
  getScenarios:    ()             => req('GET',  '/scenarios'),
  createScenario:  (body)         => req('POST', '/scenarios', body),
  deleteScenario:  (id)           => req('DELETE', `/scenarios/${id}`),
  getUsage:        ()             => req('GET',  '/usage'),
  getCalls:        ()             => req('GET',  '/calls'),
  startCall:       (scenario_id, phone_number) => req('POST', '/practice/start', { scenario_id, phone_number }),
  getTemplates:    ()             => req('GET',  '/templates'),
};
